import React from 'react';

const ActiveTreatmentPlan = ({ plan, discharge_date }) => {
  // If no plan provided, show a message
  if (!plan) {
    return (
      <div style={{ color: 'red' }}>
        No active treatment plan found. Please consult with a doctor for further instructions.
      </div>
    );
  }

  const { plan_items = [], notes = '' } = plan;

  // Group items by type
  const medications = plan_items.filter(item => item.Type === 'Medication');
  const labs = plan_items.filter(item => item.Type === 'Lab');
  const others = plan_items.filter(item => item.Type === 'Other');

  return (
    <div className="active-treatment-plan">
        <h4>Plan ID:
        <span className="plan-id">{plan.plan_id}</span>
        </h4>
      {/* Medication Section */}
      {medications.length > 0 && (
        <div className="plan-section">
          <h4>Medications</h4>
          <table className="plan-table meds-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Route</th>
                <th>Dosage</th>
                <th>Frequency</th>
              </tr>
            </thead>
            <tbody>
              {medications.map((item, idx) => (
                <tr key={idx}>
                  <td>{item.name}</td>
                  <td>{item.route || '-'}</td>
                  <td>{item.Dosage || '-'}</td>
                  <td>{item.frequency || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Lab Instructions Section */}
      {labs.length > 0 && (
        <div className="plan-section">
          <h4>Lab Instructions</h4>
          <table className="plan-table lab-table">
            <thead>
              <tr>
                <th>Instruction</th>
              </tr>
            </thead>
            <tbody>
              {labs.map((item, idx) => (
                <tr key={idx}>
                  <td>{item.name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Other Section */}
      {others.length > 0 && (
        <div className="plan-section">
          <h4>Other</h4>
          <ul className="other-list">
            {others.map((item, idx) => (
              <li key={idx}>{item.name}</li>
            ))}
          </ul>
        </div>
      )}

      {/* Notes */}
      {notes && (
        <div className="plan-section">
          <h4>Notes</h4>
          <p className="plan-notes">{notes}</p>
        </div>
      )}
    </div>
  );
};

export default ActiveTreatmentPlan;
